<script>
  import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
  } from 'sveltestrap';

  export let open, mode, handler;
</script>

<Modal isOpen={open} toggle={() => (open = !open)}>
  <ModalHeader toggle={() => (open = !open)}
    >{`${
      mode == 'order' ? 'Order' : 'Approval'
    } Confirmation Request`}</ModalHeader
  >
  <ModalBody>
    {mode == 'order'
      ? 'Are you sure you want to cancel this order and delete the items in your cart?'
      : 'Are you sure you wish to unapprove this order?'}
  </ModalBody>
  <ModalFooter>
    <Button
      color="success"
      on:click={() => {
        open = !open;
        handler();
      }}>Yes</Button
    >
    <Button color="danger" on:click={() => (open = !open)}>No</Button>
  </ModalFooter>
</Modal>
